import { useMemo } from 'react';

import { EnvironmentNameEnum, getEnvironmentName } from '@/config/environment';

export function useIsProduction(): boolean {
  return useMemo(() => getEnvironmentName() === EnvironmentNameEnum.PRODUCTION, []);
}
